import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import AdminCollectionItem from './item';
import {getDownloadURL} from '../../../../firebase/storage/download';
import cancelable from '../../../../../util/cancelable-promise';

const enhance = compose(
	lifecycle({
		componentWillMount() {
			const meta = this.props.item;

			if (meta.poster) {
				const {id, poster} = meta;
				const fetchPosterPromise = cancelable(getDownloadURL(`${id}/${poster}`));

				fetchPosterPromise.promise.then(image => this.setState({poster: image}));

				this.setState({fetchPosterPromise});
			}
		},
		componentWillUnmount() {
			if (this.state !== null) {
				this.state.fetchPosterPromise.cancel();
			}
		}
	}),
	withHandlers({
		onShowFiles: props => () => {
			props.onShowFiles(props.item.id);
		},
		onEdit: props => () => {
			props.onEdit(props.item.id);
		},
		onDelete: props => () => {
			props.onDelete(props.item.id, props.item.name, props.filesCount);
		}
	}),
);

export default enhance(AdminCollectionItem);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/item/index.js